import { render, staticRenderFns } from "./MonetarySupport.vue?vue&type=template&id=8e90477a&"
import script from "./MonetarySupport.vue?vue&type=script&lang=js&"
export * from "./MonetarySupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports